<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 payment-methods">
    <po-widget>
      <span class="po-font-text-bold">Finalização de O.P. dos últimos 15 dias</span>
      <div class="icon-loading" *ngIf="loading && !errorApi">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-text-center po-pt-5" *ngIf="errorApi">
        <app-error [message]="message"></app-error>
      </div>
      <div *ngIf="!loading && !errorApi">
        <fusioncharts width="100%" height="300" type="splinearea" [dataSource]="dataSource">
        </fusioncharts>
      </div>
    </po-widget>
  </div>
